import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BtwText } from '../BtwText';
import { Stack } from '../Stack';
export function ContainerHeader({ subtitle, title }) {
    return (_jsx(Stack, { width: "full", className: "border-b border-gray-200 pb-9", children: _jsxs(Stack, { align: "start", gap: "1", children: [_jsx(BtwText, { size: "xl", variant: "primary", weight: "semibold", className: "font-legacy", children: title }), subtitle && (_jsx(BtwText, { size: "sm", className: "font-legacy", children: subtitle }))] }) }));
}
